<template>
  <div class="toast-container">
    <div
      v-for="(t, idx) in toasts"
      :key="idx"
      class="toast"
      :class="t.type"
    >
      <span class="toast-icon">{{ iconMap[t.type] }}</span>
      <span>{{ t.message }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToastContainer',
  data() {
    return {
      toasts: [],
      iconMap: {
        success: '✅',
        error: '❌',
        warning: '⚠️'
      }
    }
  },
  methods: {
    show(message, type = 'success') {
      const toast = { message, type }
      this.toasts.push(toast)
      setTimeout(() => {
        const idx = this.toasts.indexOf(toast)
        if (idx > -1) this.toasts.splice(idx, 1)
      }, 3000)
    }
  },
  created() {
    // 全局注入 toast 方法
    this.$root.$on('show-toast', ({ message, type }) => {
      this.show(message, type)
    })
  }
}
</script>

<style scoped>
.toast-container {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 2000;
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: 380px;
  width: 100%;
}
.toast {
  padding: 14px 20px;
  border-radius: var(--radius-sm);
  background: var(--gray-900);
  color: #fff;
  font-size: 14px;
  box-shadow: var(--shadow-lg);
  animation: slideIn 0.3s ease;
  display: flex;
  align-items: center;
  gap: 12px;
}
.toast .toast-icon { flex-shrink: 0; }
.toast.success { background: #065f46; }
.toast.error { background: #991b1b; }
.toast.warning { background: #92400e; }
@keyframes slideIn {
  from { opacity: 0; transform: translateX(30px); }
  to { opacity: 1; transform: translateX(0); }
}
</style>
